import { AddButton, HeaderContainer, HeaderTitle, HeaderText, dropDownstyles, ExcelIcon } from "../Header/Header.Styled";
import Select, { SingleValue } from "react-select";
import { OptionType } from "../../pages/types";
import { statusFilterOptions } from "../../constants";
import { HiOutlineViewList } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

type Props = {
    title: string;
    buttonTitle?: string | null;
    text?: string | null;
    languages?: OptionType[];
    filterStatus?: SingleValue<OptionType>;
    filter?: boolean;
    currentLang?: SingleValue<OptionType>;
    accounts?: boolean;
    moduleTitle?: string | null;
    secondaryButtonTitle?: string | null;
    secondaryButtonExcel?: boolean;
    onClick?: () => void;
    onClickSecondary?: () => void;
    onClickEdit?: () => void;
    onChangeLang?: (newValue: SingleValue<OptionType>) => void;
    onChangeFilter?: (newValue: SingleValue<OptionType>) => void;
}
const Header: React.FC<Props> = ({
    title, text, buttonTitle, languages, currentLang, accounts, filterStatus, filter, moduleTitle,
    secondaryButtonTitle, secondaryButtonExcel, onClick, onClickSecondary, onClickEdit, onChangeLang, onChangeFilter
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick()
        }
    }
    const handleLangChange = (newValue: SingleValue<OptionType>) => {
        if (onChangeLang) {
            onChangeLang(newValue)
        }
    }
    const handleFilterChange = (newValue: SingleValue<OptionType>) => {
        if (onChangeFilter) {
            onChangeFilter(newValue)
        }
    }

    const handleClickEdit = () => {
        if (onClickEdit) {
            onClickEdit()
        }
    }

    const handleClickSecondary = () => {
        if (onClickSecondary) {
            onClickSecondary()
        }
    }
    
    return (
        <HeaderContainer>
            <div>
                <HeaderTitle>
                    {title}
                </HeaderTitle>
                {text &&
                    <HeaderText>
                        {text}
                    </HeaderText>}
            </div>
            <div style={{ display: 'flex' }}>
                {filter && <Select
                    styles={dropDownstyles}
                    value={filterStatus}
                    onChange={handleFilterChange}
                    options={statusFilterOptions}
                    isSearchable={false}
                />}
                {secondaryButtonTitle && <AddButton onClick={handleClickSecondary} className="me-3">
                    {secondaryButtonExcel ? <ExcelIcon src={require('../../assets/excel.png')} /> : <FaPlus size={12} className="me-1" />}
                    {secondaryButtonTitle}
                </AddButton>}
                {buttonTitle && <AddButton onClick={handleClick} className="me-3">
                    {accounts ? <ExcelIcon src={require('../../assets/excel.png')} /> :
                        <FaPlus size={12} className="me-1"/>}
                    {buttonTitle}
                </AddButton>}
                {moduleTitle && <AddButton onClick={handleClickEdit}>
                    <HiOutlineViewList size={18} className="me-1"/>
                    {moduleTitle}
                </AddButton>}
                {languages && <div className="ms-3">
                    <Select
                        styles={dropDownstyles}
                        value={currentLang}
                        onChange={handleLangChange}
                        options={languages}
                        isSearchable={false}
                    />
                </div>}
            </div>
        </HeaderContainer>

    )
}
export default Header;
